module.exports = __webpack_public_path__ + "img/Img12_212552_CkEe-22-314.17805c95.jpg";